import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";
import { authAPI, resetSessionTimer } from '../services/api';
const Login = () => {
    const [form, setForm] = useState({
        username: "",
        password: "",
    });

    const [loading, setLoading] = useState(false);

    const { login } = useAuth();

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            await login(form.username, form.password);

            toast.success("Welcome back!");

            navigate("/dashboard");
        } catch (err) {
            toast.error("Invalid username or password");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card">

                <div className="auth-logo">
                    <div className="logo-icon">🎓</div>
                    <h2>SchoolERP</h2>
                    <p>School Management System</p>
                </div>

                <form onSubmit={handleSubmit}>

                    <div className="mb-3">
                        <label className="form-label">
                            Username
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Username"
                            value={form.username}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    username: e.target.value,
                                })
                            }
                            required
                        />
                    </div>

                    <div className="mb-4">
                        <label className="form-label">
                            Password
                        </label>

                        <input
                            type="password"
                            className="form-control"
                            placeholder="Enter Password"
                            value={form.password}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    password: e.target.value,
                                })
                            }
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Signing In...
                            </>
                        ) : (
                            "Sign In"
                        )}
                    </button>
                </form>

                {/* Divider */}
                <div className="text-center my-4">
                    <span style={{ color: "#94a3b8" }}>
                        ───────── OR ─────────
                    </span>
                </div>

                {/* Signup Button */}
                <button
                    className="btn btn-success w-100"
                    onClick={() => navigate("/signup")}
                >
                    🏫 Create School Account
                </button>

                {/* Forgot Password */}
                <div className="text-center mt-3">
                    <button
                        className="btn btn-link"
                        onClick={() => navigate("/forgot-password")}
                    >
                        Forgot Password?
                    </button>
                </div>

                {/* Demo */}
                <div
                    className="mt-4 p-3 rounded"
                    style={{
                        background: "#f8fafc",
                        fontSize: 12,
                    }}
                >
                </div>

            </div>
        </div>
    );
};

export default Login;